import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { VtSettingsListGroupLink } from '@shared/interfaces/settings-list-group-link';
import { DepartmentSettingsRouteName } from '@pages/settings-page/settings-route-names';

export const departmentMenuItemTitle = 'Settings.Departments';

export const departmentMenuItemLinks: VtSettingsListGroupLink[] = [
  {
    label: 'Settings.Departments.DepartmentLink',
    routerLink: DepartmentSettingsRouteName.Departments,
    permissions: [RolesAndPermissions.DepartmentSettingsRead],
  },
];

export enum DepartmentQuickFilterId {
  All = 'All',
  Active = 'Active',
  Deleted = 'Deleted',
}
